import { useQuery } from "@tanstack/react-query";
import type { ProvenanceResponse } from "@insights/contracts";
import { api } from "../../../api";

export function useProvenance(workspaceId: string | undefined, buildId: string | undefined, state: boolean, enabled: boolean) {
  return useQuery({
    queryKey: ["provenance", workspaceId, buildId, state],
    enabled: enabled && Boolean(workspaceId && buildId),
    refetchInterval: (query) => enabled && query.state.data?.computation === "pending" ? 2000 : false,
    queryFn: () => api<ProvenanceResponse>(`/${workspaceId}/builds/${buildId}/${state ? "state-provenance" : "provenance"}`),
  });
}
